import classNames from "classnames";
import React from "react";

import iconButtonDefaultImage from "../../assets/ui/buttons/icon-button-default.png";
import iconButtonHoverImage from "../../assets/ui/buttons/icon-button-hover.png";

import "./IconButton.scss";

const IconButton = ({ icon, isActive, disabled, onClick }) => (
  <button
    className={classNames("icon-button", {
      "icon-button--active": isActive,
    })}
    onClick={onClick}
    disabled={disabled}
  >
    <img
      className="icon-button__background"
      src={iconButtonDefaultImage}
      alt=""
    />
    <img
      className="icon-button__background icon-button__background--accent"
      src={iconButtonHoverImage}
      alt=""
    />
    <img className="icon-button__icon" src={icon} alt="" />
  </button>
);

export default IconButton;
